// Gets user location and sets pincode in session storage
document.addEventListener("DOMContentLoaded", function () {
    if (sessionStorage.getItem("pincode")) {
      return;
    }
    if (!navigator.geolocation) {
      console.error("Geolocation is not supported by this browser.");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          if (!lat || !lng) {
            console.warn("Latitude or longitude is missing.");
            return;
          }
          sessionStorage.setItem('latitude', lat);
          sessionStorage.setItem('longitude', lng);
          const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBor61Uz7MhfKWKeF-OwNqqSv4i70OSe5U`;
  
          const response = await fetch(url);
          if (!response.ok) {
            console.error(`Error fetching geocode data: ${response.statusText}`);
            return;
          }
  
          const data = await response.json();
          const result = data.results[0];
          if (!result || !result.address_components) {
            console.error("Invalid geocode result.");
            return;
          }
  
          const postalCodeComponent = result.address_components.find((component) =>
            component.types.includes("postal_code")
          );
          const pincode = postalCodeComponent ? postalCodeComponent.long_name : null;
  
          if (!pincode) {
            console.warn("Pincode could not be extracted.");
            return;
          }
  
          sessionStorage.setItem("pincode", pincode);
        } catch (error) {
          console.error("Error fetching pincode:", error);
        }
      },
      (error) => {
        console.error("Geolocation error:", error.message);
      }
    );
  });
  
  if(!customElements.get("cart-pincode")){
    class CartPincode extends HTMLElement {
      constructor() {
        super();
        this.initialize();
      }
  
      initialize() {
        this.productId = this.getAttribute("data-product-id");
        this.pincode = sessionStorage.getItem("pincode") || null;
        this.pincodeDeliveryDays = this.querySelector('.pincode-delivery-days');
        this.pincodeCustomerMsgWrapper = this.querySelector(".pincode-customer_msg-wrapper");
        this.pincodeCod = this.querySelector('.pincode-cod');
        this.pincodeCodAvailable = this.querySelector('.pincode-cod_available');
        this.pincodeMsg = this.querySelector('.pincode-msg');
        this.getServicability();
      }
  
      async getServicability(){
        if(!this.pincode || !this.productId){
          return
        }
        const url = 'https://snooplaypinuat.marmeto.com/api/multiZoneEdd';
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(
                  [
                    {
                        "productId": this.productId,
                        "deliveryDistrictPincode": this.pincode
                    }
                  ]
                )
            });
            const data = await response.json();
            if (data.data && data.data[0].EstimatedDeliveryDays) {
                this.pincodeCustomerMsgWrapper.classList.remove('hidden');
                let productPincodeData = data.data[0].EstimatedDeliveryDays
                // Calculate the estimated delivery date(s)
                const currentDate = new Date();
                let deliveryMessage = '';
                if (productPincodeData.includes('-')) {
                    // Format "03-04": Calculate both dates
                    const [startDays, endDays] = productPincodeData.split('-').map(Number);
                    const startDate = new Date(currentDate);
                    const endDate = new Date(currentDate);
                    startDate.setDate(currentDate.getDate() + startDays);
                    endDate.setDate(currentDate.getDate() + endDays);
                    const options = { month: 'short', day: 'numeric' };
                    const formattedStartDate = startDate.toLocaleDateString(undefined, options);
                    const formattedEndDate = endDate.toLocaleDateString(undefined, options);
                    deliveryMessage = `${formattedStartDate} - ${formattedEndDate}`;
                }else if(productPincodeData === 'Today/Tomorrow'){
                  deliveryMessage = 'Today / Tomorrow'
                }
                this.pincodeDeliveryDays.innerHTML = deliveryMessage;
                if (data.data[0].COD) {
                  this.pincodeCod.classList.remove('hidden');
                  this.pincodeCodAvailable.innerHTML = data.data[0].COD;
                }else{
                  this.pincodeCod.classList.add('hidden');
                }
            } else {
              console.warn(`No data found for cart item - ${this.productId} serviceability`);
              this.pincodeCustomerMsgWrapper.classList.add('hidden');
              this.userMessage("Not serviceable in your area!");
            }   
        } catch (error) {
            console.error("Error fetching serviceability data:", error);
            this.pincodeCustomerMsgWrapper.classList.add('hidden');
        }
      }
  
      userMessage(msg){
        this.pincodeMsg.textContent = msg;
        this.pincodeMsg.classList.add('error');
        setTimeout(() => {
            this.pincodeMsg.textContent = ""
            this.pincodeMsg.classList.remove('error');
        }, 3000);
     }
    }
    customElements.define("cart-pincode", CartPincode);
  }
  
  if(!customElements.get("cart-pincode-check")){
    class CartPincodeCheck extends HTMLElement {
      constructor() {
        super();
        this.pincodeLocationBtn = this.querySelector('.pincode-location');
        this.pincodeMsg = this.querySelector('.pincode-msg');
        this.pincodeInput = this.querySelector('.pincode-input');
        this.pincodeCheckBtn = this.querySelector('.pincode-check');
        this.pincode = sessionStorage.getItem('pincode') || null;
      }
  
      connectedCallback(){
        this.pincodeLocationBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.target.parentElement.classList.add('spinner-loading');
          this.getPincode();
          setTimeout(() => {
            e.target.parentElement.classList.remove('spinner-loading');
          }, 200);
        });
        this.pincodeCheckBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.pincode = this.pincodeInput.value;
            e.target.parentElement.classList.add('spinner-loading');
            if(/^\d{6}$/.test(this.pincode)){
                sessionStorage.setItem('pincode', this.pincode);
                this.getServiceability();
            } else {
                this.userMessage("Please enter a valid pincode!");
            }
            setTimeout(() => {
              e.target.parentElement.classList.remove('spinner-loading');
            }, 500);
        });
        if(this.pincode){
            this.pincodeInput.value = this.pincode;
        } else {
            this.pincodeInput.value = '';
        }
      }
  
      getServiceability(){
        document.querySelectorAll("cart-pincode").forEach(element => {
          element.initialize();
        });
      }
  
      async getPincodeFromCoords(lat, lng){
        if(!lat || !lng){
            this.userMessage("Unable to fetch pincode. Please try again later.");
            return
        };
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyBor61Uz7MhfKWKeF-OwNqqSv4i70OSe5U`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            if (data.status === "OK") {
                const result = data.results[0];
                this.pincode = this.extractPostalCode(result.address_components);
                sessionStorage.setItem('pincode', this.pincode);
                this.pincodeInput.value = this.pincode;
                this.getServiceability();
            } else {
                this.userMessage("Unable to fetch pincode. Please try again later.");
            }
        } catch (error) {
            this.userMessage("Error fetching geolocation data.");
        }
      }
  
      getPincode() {
        const storedLat = sessionStorage.getItem('latitude');
        const storedLng = sessionStorage.getItem('longitude');
        if (storedLat && storedLng) {
          this.getPincodeFromCoords(parseFloat(storedLat), parseFloat(storedLng));
        } else {
          // Fetch coordinates and store them
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const lat = position.coords.latitude;
              const lng = position.coords.longitude;
              // Store in sessionStorage
              sessionStorage.setItem('latitude', lat);
              sessionStorage.setItem('longitude', lng);
              this.getPincodeFromCoords(lat, lng);
            },
            (error) => {
              console.error(error);
              this.userMessage("Please enable location permission from settings and try again!");
            }
          );
        }
      }
      
      extractPostalCode(components) {
        const comp = components.find(c => c.types.includes("postal_code"));
        return comp ? comp.long_name : null;
     }
  
      userMessage(msg){
        this.pincodeMsg.textContent = msg;
        this.pincodeMsg.classList.add('error');
        setTimeout(() => {
            this.pincodeMsg.textContent = ""
            this.pincodeMsg.classList.remove('error');
        }, 3000);
     }
    }
    customElements.define("cart-pincode-check", CartPincodeCheck);
  }